'use client'

import type { ReactNode } from 'react'

import { cn } from '~/core/ui/utils'

interface ContainerProps {
  ref?: React.Ref<HTMLDivElement>
  children?: ReactNode
  overrideClass?: string
  centerContent?: boolean
}

const Container = ({
  overrideClass = '',
  centerContent = false,
  ref,
  ...rest
}: ContainerProps) => {
  return (
    <div
      ref={ref}
      className={cn(
        'mx-auto',
        overrideClass,
        centerContent ? 'flex flex-col items-center' : ''
      )}
      {...rest}
    />
  )
}

Container.displayName = 'Container'

export { Container }
export type { ContainerProps }
